import PropTypes from "prop-types";
import { childrenPropType, classNamePropType, onSelectPropType } from "../../common";

/**
 * PropTypes for Dropdown component
 *
 * @property {React.ReactNode} [children] - Dropdown trigger element
 * @property {React.ReactNode} [content] - Dropdown menu content
 * @property {function} [onSelect] - Selection handler callback
 * @property {string} [className] - Additional CSS classes
 * @property {('click'|'hover')} [trigger] - Trigger mode for dropdown
 * @property {('bottom'|'top'|'left'|'right')} [placement] - Dropdown placement relative to trigger
 * @property {boolean} [disabled] - Disable dropdown interaction
 */
export const dropdownPropTypes = {
  children: childrenPropType,
  content: childrenPropType,
  onSelect: onSelectPropType,
  className: classNamePropType,
  trigger: PropTypes.oneOf(["click", "hover"]),
  placement: PropTypes.oneOf(["bottom", "top", "left", "right"]),
  disabled: PropTypes.bool,
};
